<template>
    <div>
        <van-Row class="bmwcCon">
            <van-Col span="24">
              <div class="shxxCon">
                <div class="bmsuccess"><img :src=bmsuccess width="120" /></div>
                <p>请等待主办方审核，结果将以短信下发至您的手机，你也可点击下方按钮查看审核结果。</p>
                <div style="margin:50px 16px 16px;"><van-button round block type="info" class="bottom-button" @click="ckbmxx">查看审核结果</van-button></div>
              </div>
            </van-Col>

        </van-Row>
    </div>
</template>

<script>
export default {
    data(){
        return{
            bmsuccess:require('@/assets/images/bmsuccess.png'),
        }
    },
    mounted() {

    },
    methods:{

        //查看报名信息
        ckbmxx(){
            this.$router.push('/personal/login?meetingId='+this.$cookies.get('meetingId'));
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bmsuccess{
    text-align: center;
    padding:40px 0 20px;
  }
  .shxxCon p{
    padding:0 40px;
    line-height: 26px;
    text-align: justify;
    color:#676767;
  }
</style>



// WEBPACK FOOTER //
// src/components/Charge/voucherIndex.vue